export const I18N_DEFAULT_LOCALE_OVERRIDE =
  process.env.VUE_APP_I18N_DEFAULT_LOCALE_OVERRIDE || "";

export const API_BASE_URL = process.env.VUE_APP_BASE_URL_CHAT || "";
export const UPMAN_MEDIA_BASE_URL =
  process.env.VUE_APP_UPMAN_MEDIA_BASE_URL || "";
// export const BASE_URL_IA = process.env.VUE_APP_BASE_URL_INTERACTIVE || "";
